"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageUser = void 0;
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _Modal = _interopRequireDefault(require("react-bootstrap/Modal"));
var _react = _interopRequireWildcard(require("react"));
var _DmsAltBox = require("../../components/DmsAltBox/DmsAltBox");
var _DmsFetch = require("../../components/DmsFetch/DmsFetch");
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _DmsButton = require("../../components/DmsButton/DmsButton");
var _DmsTokenHook = require("../../components/DmsTokenHook/DmsTokenHook");
var _sweetalert = _interopRequireDefault(require("sweetalert2"));
var _reactBootstrap = require("react-bootstrap");
var _DmsPasswordValidation = require("../../components/DmsPasswordValidation/DmsPasswordValidation");
var _material = require("@mui/material");
var _DmsUserTable = require("../../components/DmsUserTable/DmsUserTable");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*
 * Description: This component is the DMS users page
 * Props: none
 */

async function changePassword(password, pk, login) {
  const token = (0, _DmsTokenHook.getToken)();
  const data = {
    user_password: password,
    user_login: login
  };
  try {
    const url = "/user/password/".concat(pk);
    const putData = await (0, _DmsFetch.fetchData)(url, "PUT", token.access_token, data);
    if ((putData === null || putData === void 0 ? void 0 : putData.status) !== 200) {
      var _putData$data;
      _sweetalert.default.fire({
        icon: "error",
        title: putData === null || putData === void 0 || (_putData$data = putData.data) === null || _putData$data === void 0 ? void 0 : _putData$data.detail
      });
    } else {
      var _putData$data2;
      _sweetalert.default.fire({
        icon: "success",
        title: putData === null || putData === void 0 || (_putData$data2 = putData.data) === null || _putData$data2 === void 0 ? void 0 : _putData$data2.detail
      });
    }
  } catch (error) {
    _sweetalert.default.fire({
      icon: "error",
      title: _reactIntlUniversal.default.get("ErrorPostingData").d("Error posting data")
    });
    throw new Error(_reactIntlUniversal.default.get("ErrorPostingData").d("Error posting data"), error);
  }
}

/**
 * Component representing the Users page in the DMS.
 * Handles user management, password change, and CRUD operations.
 */
const DmsPageUser = () => {
  const [passwordDisplay, setPasswordDisplay] = (0, _react.useState)(false);
  const [password, setPassword] = (0, _react.useState)("");
  const [confirmPassword, setConfirmPassword] = (0, _react.useState)("");
  const [login, setLogin] = (0, _react.useState)("");
  const [pk, setPk] = (0, _react.useState)("");
  const [modalTitle, setModalTitle] = (0, _react.useState)("");
  const passwordPlaceHolder = _reactIntlUniversal.default.get("password").d("password");
  const handleCloseModal = () => {
    setPasswordDisplay(false);
    setPassword("");
    setConfirmPassword("");
    setLogin("");
    setPk("");
    setModalTitle("");
  };

  /**
   * Handles the submission of the password change form.
   * If passwords match, calls `changePassword` function.
   * Otherwise, displays an error message.
   */
  const handleSubmitPassword = data => {
    if (confirmPassword === password) {
      changePassword(password, pk, login);
      handleCloseModal();
    } else {
      const confirmPasswordErrorTitle = _reactIntlUniversal.default.get("FailedOnPasswordConfirmation").d("Failed on password confirmation!");
      _sweetalert.default.fire({
        icon: "error",
        title: confirmPasswordErrorTitle,
        customClass: {
          container: 'swal-overlay'
        },
        didOpen: () => {
          document.querySelector(".swal-overlay").style.zIndex = 9999;
        }
      });
    }
  };

  /**
   * Opens the password change modal for a specific user.
   * @param {Object} data The user data containing pk and login
   */
  const passwordPopup = data => {
    setPk(data.pk);
    setLogin(data.user_login);
    setPassword("");
    setConfirmPassword("");
    setPasswordDisplay(true);
    let changePasswordText = _reactIntlUniversal.default.get("Changepassword").d("Change password");
    let forUserText = _reactIntlUniversal.default.get("forUser").d("for user");
    setModalTitle("".concat(changePasswordText, " ").concat(forUserText, " '").concat(data.user_login, "'"));
  };
  const routes = [{
    link: "/home",
    text: _reactIntlUniversal.default.get("Home").d("Home")
  }, {
    text: _reactIntlUniversal.default.get("System").d("System")
  }, {
    text: _reactIntlUniversal.default.get("Users").d("Users")
  }];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: "Users",
    routes: routes
  }, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: "1.1rem"
    }
  }, _reactIntlUniversal.default.get("Users").d("Users"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_DmsUserTable.DmsUserTable, {
    passwordPopup: passwordPopup
  })))), /*#__PURE__*/_react.default.createElement(_Modal.default, {
    show: passwordDisplay,
    onHide: handleCloseModal,
    keyboard: true,
    backdrop: true
  }, /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmitPassword
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Header, null, /*#__PURE__*/_react.default.createElement(_Modal.default.Title, null, modalTitle)), /*#__PURE__*/_react.default.createElement(_Modal.default.Body, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: "mb-3",
    controlId: "formChangePassword"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, _reactIntlUniversal.default.get("NewPassword").d("New password")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    onChange: e => setPassword(e.target.value),
    type: "password",
    placeholder: passwordPlaceHolder,
    value: password
  })), /*#__PURE__*/_react.default.createElement(_DmsPasswordValidation.DmsPasswordValidation, {
    password: password,
    confirmPassword: confirmPassword
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: "mb-3",
    controlId: "formConfirmChangePassword"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, _reactIntlUniversal.default.get("ConfirmNewPassword").d("Confirm new password")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    onChange: e => setConfirmPassword(e.target.value),
    type: "password",
    placeholder: passwordPlaceHolder,
    value: confirmPassword
  })))), /*#__PURE__*/_react.default.createElement(_Modal.default.Footer, null, /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    variant: "success",
    text: _reactIntlUniversal.default.get("Confirm").d("Confirm"),
    onClick: () => {
      handleSubmitPassword();
    } // This button will submit the form
  }), /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    variant: "secondary",
    text: _reactIntlUniversal.default.get("Cancel").d("Cancel"),
    onClick: handleCloseModal
  })))));
};
exports.DmsPageUser = DmsPageUser;